/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_Start_TimeInputs */



/**
* | output |
* | --- |
* | "Include Start Time" |
*
* @param {Transcript_Export_Include_Start_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_start_time = /** @type {((inputs?: Transcript_Export_Include_Start_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_Start_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inclure l'heure de debut")
	if (locale === "de") return /** @type {LocalizedString} */ ("Startzeit einschließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Includi ora di inizio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Укажите время начала")
	if (locale === "es") return /** @type {LocalizedString} */ ("Incluir hora de inicio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("包括开始时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始時間を含める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रारंभ समय शामिल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incluir horário de início")
	return /** @type {LocalizedString} */ ("Include Start Time")
});